//#region IMPORTS
import { PlusCircleIcon } from "@heroicons/react/20/solid";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
import classNames from "../../helpers/classNames";
//#endregion

//#region INTERFACE
interface Props {
  tooltipContent?: string;
  createHandler: () => void;
  tooltipId?: string;
  disabled?: boolean;
  hide?: boolean;
}
//#endregion

export default function MainTableRowActionCreate({
  tooltipContent = "Create new item",
  createHandler,
  tooltipId,
  disabled = false,
  hide = false,
}: Props) {
  //#region SETUP
  return !hide ? (
    <Fragment>
      <button
        data-tooltip-delay-show={100}
        data-tooltip-content={tooltipContent}
        data-tooltip-place="right"
        data-tooltip-id={tooltipId + "createInTable"}
        className={classNames(
          disabled
            ? "hover:cursor-not-allowed bg-gray-400"
            : "hover:cursor-pointer hover:bg-pink-500 bg-pink-800 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600",
          "rounded-full p-0.5 text-white h-6 w-6 flex items-center justify-center"
        )}
        disabled={disabled}
        onClick={createHandler}
        type="button"
      >
        <PlusCircleIcon aria-hidden="true" className="h-4 w-4" />
      </button>
      {tooltipId && !disabled && (
        <Tooltip id={tooltipId + "createInTable"} className="font-bold" />
      )}
    </Fragment>
  ) : null;
}
